module.exports = __webpack_public_path__ + "img/image11.71bbaff8.png";